<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m1 18 6-8 4.5 6H19l-5-6.65-2.5 3.3L10.25 11 14 6l9 12H1Zm4-2h4l-2-2.675L5 16Z"
    />
  </svg>
</template>
